import React, { useState } from 'react';
import SEO from '../Components/SEO';
import 'bootstrap/dist/css/bootstrap.min.css';

const Contact = () => {
  const [formState, setFormState] = useState({
    name: '',
    phone: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    const phoneNumber = "918374771149"; // WhatsApp number with country code

    // Construct the formatted message for WhatsApp
    const messageText = `*New Inquiry - Sree Raghavendra*\n\n*Name:* ${formState.name}\n*Phone:* ${formState.phone}\n*Message:* ${formState.message}`;

    // Encode the message to ensure safe URL parsing
    const encodedMessage = encodeURIComponent(messageText);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    // Open WhatsApp in a new tab
    window.open(whatsappUrl, '_blank');
  };

  return (
    <>
      <style>{`
        /* Custom Animations */
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes borderGlow {
          0%, 100% { border-color: rgba(252, 115, 3, 0.2); }
          50% { border-color: rgba(252, 115, 3, 0.7); }
        }

        .animate-fade-in-up {
          animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
          opacity: 0; /* Solves visual flash before animation plays */
        }

        .animation-delay-100 { animation-delay: 100ms; }
        .animation-delay-200 { animation-delay: 200ms; }
        .animation-delay-300 { animation-delay: 300ms; }

        /* Custom Theme Background Gradient */
        .bg-custom-dark {
          background: linear-gradient(
            135deg,
            #f8f3ed 0%,
            #efe4d4 100%
          );
        }

        /* Soft White Cards with Premium Depth and Blur */
        .bg-custom-card {
          background-color: rgba(255, 255, 255, 0.85);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(0, 0, 0, 0.06) !important;
          border-radius: 16px;
          transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
          box-shadow: 0 8px 30px rgba(160, 140, 115, 0.1);
        }

        .bg-custom-card:hover {
          border-color: rgba(252, 115, 3, 0.4) !important;
          transform: translateY(-6px);
          box-shadow: 0 15px 35px rgba(252, 115, 3, 0.12);
        }

        .text-custom-orange {
          color: #fc7303;
        }

        .bg-custom-orange {
          background-color: #fc7303;
        }

        /* Architectural background grid lines */
        .bg-grid {
          position: absolute;
          inset: 0;
          opacity: 0.08;
          pointer-events: none;
          background-image: 
            linear-gradient(to right, #8b7d6b 1px, transparent 1px),
            linear-gradient(to bottom, #8b7d6b 1px, transparent 1px);
          background-size: 50px 50px;
        }

        /* Sophisticated Icon Box Styling */
        .icon-box {
          padding: 12px;
          border-radius: 12px;
          background-color: rgba(252, 115, 3, 0.08);
          color: #fc7303;
          transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
          flex-shrink: 0;
        }

        .bg-custom-card:hover .icon-box {
          background-color: #fc7303;
          color: #ffffff;
          transform: scale(1.05);
        }

        /* Premium Input Styling */
        .custom-input {
          background-color: #ffffff !important;
          color: #2b2b36 !important;
          border: 1px solid rgba(0, 0, 0, 0.12) !important;
          padding: 14px 18px;
          border-radius: 10px;
          transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
        }

        .custom-input:focus {
          background-color: #ffffff !important;
          color: #000000 !important;
          border-color: #fc7303 !important;
          box-shadow: 0 0 18px rgba(252, 115, 3, 0.15) !important;
          animation: borderGlow 2.5s infinite;
          outline: none;
        }

        .custom-input::placeholder {
          color: #a0aec0 !important;
        }

        /* Metallic shine hover effect for the button */
        .btn-shine {
          position: relative;
          overflow: hidden;
          background-color: #fc7303 !important;
          color: #ffffff !important;
          font-weight: 700;
          border: none;
          padding: 15px;
          border-radius: 10px;
          box-shadow: 0 6px 22px rgba(252, 115, 3, 0.3);
          transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
          text-transform: uppercase;
          letter-spacing: 1.2px;
        }

        .btn-shine::after {
          content: '';
          position: absolute;
          top: -50%;
          left: -60%;
          width: 30%;
          height: 200%;
          background: rgba(255, 255, 255, 0.35);
          transform: rotate(30deg);
          transition: all 0.6s ease;
        }

        .btn-shine:hover::after {
          left: 120%;
        }

        .btn-shine:hover {
          background-color: #e06200 !important;
          box-shadow: 0 8px 28px rgba(252, 115, 3, 0.45);
          transform: translateY(-3px);
        }

        .btn-shine:active {
          transform: translateY(-1px);
        }

        /* Custom typography label style */
        .custom-label {
          font-size: 11px;
          font-weight: 700;
          color: #5d5d6a;
          text-transform: uppercase;
          letter-spacing: 1.2px;
          margin-bottom: 8px;
        }

        /* Map Card custom styles */
        .map-wrapper {
          overflow: hidden;
          border-radius: 12px;
          border: 1px solid rgba(0, 0, 0, 0.08);
        }
      `}</style>

      
      <SEO
        title="Contact Sree Raghavendra Doors & Hardware | Rajamahendravaram"
        description="Visit our doors, plywood, and architectural hardware showroom in Rajahmundry. Located on Morampudi - Kesavaram Road, Aditya Nagar. Direct call (+91 83747 71149), WhatsApp, store hours, and driving directions."
        canonicalUrl="/contact"
        keywords="sree raghavendra contact, doors showroom rajahmundry, morampudi hardware shop, plywood store phone number rajamahendravaram"
        ogImage="https://raghavendradoorsandhardware.in/assets/prelaminated.png"
      />

      <div className="min-vh-100 bg-custom-dark py-5 px-3 px-sm-4 relative position-relative overflow-hidden">

        {/* Subtle background grid lines */}
        <div className="bg-grid"></div>

        <div className="container position-relative z-index-10" style={{ maxWidth: '1140px' }}>

          {/* Header Section */}
          <div className="text-center mb-5  animate-fade-in-up">
            <span
              className="d-block text-custom-orange text-uppercase small"
              style={{
                fontWeight: '800',
                letterSpacing: '2px'
              }}
            >
              Get In Touch
            </span>
            <h1 className="mt-2 display-6 fw-extrabold text-dark tracking-tight" style={{ color: '#1a1a24', fontWeight: '800' }}>
              SREE RAGHAVENDRA
            </h1>
            <div className="bg-custom-orange mx-auto mt-3 rounded-pill" style={{ height: '4px', width: '90px' }}></div>
            <p className="mt-3 mx-auto" style={{ maxWidth: '550px', fontSize: '15px', color: '#5d5d6a' }}>
              Have inquiries about timber grades, customized doors, or architectural hardware? Reach out to our specialists today.
            </p>
          </div>

          {/* Main Grid Layout */}
          <div className="row g-4 align-items-stretch">

            {/* Left Section: Information Cards & Map Location */}
            <div className="col-12 col-lg-5 d-flex flex-column gap-4">

              {/* Cards row */}
              <div className="row g-3 row-cols-1 row-cols-md-3 row-cols-lg-1">

                {/* Location Card */}
                <div className="col">
                  <div className="bg-custom-card p-4 h-100 animate-fade-in-up animation-delay-100">
                    <div className="d-flex align-items-start gap-3">
                      <div className="icon-box">
                        <svg className="bi" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                      </div>
                      <div>
                        <h5 className="fw-bold mb-1 fs-6" style={{ color: '#1c1c24' }}>Our Showroom</h5>
                        <p className="small mb-0" style={{ lineHeight: '1.6', color: '#5d5d6a' }}>
                          Sree Raghavendra Doors and Hardware,<br />
                          Morampudi - Kesavaram Rd,,<br />
                          Rajamahendravaram, Andhra Pradesh, 533107
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Contact details Card */}
                <div className="col">
                  <div className="bg-custom-card p-4 h-100 animate-fade-in-up animation-delay-200">
                    <div className="d-flex align-items-start gap-3">
                      <div className="icon-box">
                        <svg className="bi" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.94.725l.548 2.2a1 1 0 01-.321.988l-1.305.98a10.582 10.582 0 004.872 4.872l.98-1.305a1 1 0 01.988-.321l2.2.548a1 1 0 01.725.94V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                        </svg>
                      </div>
                      <div>
                        <h5 className="fw-bold mb-1 fs-6" style={{ color: '#1c1c24' }}>Call & Email</h5>
                        <p className="mb-1 small text-break">
                          <a href="tel:+918374771149" className="text-custom-orange fw-bold text-decoration-none d-block">
                            +91 83747 71149
                          </a>
                          <a href="tel:+919849659309" className="text-secondary fw-semibold text-decoration-none small d-block mt-1">
                            +91 98496 59309
                          </a>
                        </p>
                        <p className="small mb-0 text-break font-monospace">
                          <a href="mailto:koushikmattapalli9550@gmail.com" className="text-decoration-none" style={{ color: '#5d5d6a' }}>
                            koushikmattapalli9550@gmail.com
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Hours Card */}
                <div className="col">
                  <div className="bg-custom-card p-4 h-100 animate-fade-in-up animation-delay-300">
                    <div className="d-flex align-items-start gap-3">
                      <div className="icon-box">
                        <svg className="bi" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <div>
                        <h5 className="fw-bold mb-1 fs-6" style={{ color: '#1c1c24' }}>Business Hours</h5>
                        <p className="small mb-0" style={{ color: '#5d5d6a' }}>
                          Mon - Sat: <span className="fw-medium" style={{ color: '#1c1c24' }}>9:00 AM - 8:00 PM</span>
                        </p>
                        <p className="text-danger small mb-0 mt-1">
                          Sunday: Closed
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              {/* Interactive Google Map Location Card */}
              <div className="bg-custom-card p-3 animate-fade-in-up animation-delay-300 d-flex flex-column justify-content-between flex-grow-1">
                <div>
                  <h6 className="fw-bold mb-2 text-dark d-flex align-items-center gap-2">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" className="text-custom-orange">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                    </svg>
                    Interactive Map Location
                  </h6>
                  <div className="map-wrapper mb-2">
                    <iframe
                      title="Sree Raghavendra Doors Location"
                      src="https://www.google.com/maps?q=Sree+Raghavendra+Doors+Hardware+Aditya+Nagar+Rajamahendravaram+Andhra+Pradesh&output=embed"
                      width="100%"
                      height="260"
                      style={{
                        border: 0,
                        display: "block",
                        borderRadius: "12px"
                      }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    />
                  </div>
                </div>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Sree+Raghavendra+Doors+Hardware+Aditya+Nagar+Rajamahendravaram+Andhra+Pradesh"
                  className="srf-dir-btn"
                >
                  <i className="fa-solid fa-diamond-turn-right" />
                  Get Directions
                </a>
              </div>

            </div>

            {/* Right Section: Form Wrapper */}
            <div className="col-12 col-lg-7">
              <div className="bg-custom-card p-4 p-sm-5 position-relative d-flex flex-column animate-fade-in-up animation-delay-200">
                <div className="bg-custom-orange position-absolute top-0 end-0" style={{ width: '90px', height: '4px', marginRight: '40px' }}></div>

                <h2
                  className="h4 fw-bold mb-2"
                  style={{
                    color: '#1c1c24'
                  }}
                >
                  Send an Inquiry
                </h2>
                <p className="small mb-4" style={{ color: '#5d5d6a' }}>Fill out the form below and our team will get back to you within 24 business hours.</p>

                <form onSubmit={handleSubmit}>

                  {/* Name Input */}
                  <div className="mb-4">
                    <label className="custom-label d-block">
                      Your Name
                    </label>
                    <input
                      type="text"
                      value={formState.name}
                      onChange={(e) => setFormState({ ...formState, name: e.target.value })}
                      placeholder="Enter your full name"
                      className="form-control custom-input"
                      required
                    />
                  </div>

                  {/* Email Input */}
                  <div className="mb-4">
                    <label className="custom-label d-block">
                     Phone Number
                    </label>

                    <input
                      type="tel"
                      value={formState.phone}
                      onChange={(e) =>
                        setFormState({
                          ...formState,
                          phone: e.target.value
                        })
                      }
                      placeholder="Enter your phone number"
                      className="form-control custom-input"
                      pattern="[0-9]{10}"
                      maxLength={10}
                      required
                    />
                  </div>

                  {/* Message Input */}
                  <div className="mb-4">
                    <label className="custom-label d-block">
                      Requirement Details
                    </label>
                    <textarea
                      value={formState.message}
                      onChange={(e) => setFormState({ ...formState, message: e.target.value })}
                      placeholder="Describe your requirements (e.g., WPVC doors, plywood thickness, hardware fittings...)"
                      rows="4"
                      className="form-control custom-input"
                      style={{ resize: 'none' }}
                      required
                    ></textarea>
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    className="btn btn-shine w-100 mt-2"
                  >
                    Send Message
                  </button>

                </form>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;